import React from 'react';
import cx from 'classnames';
import { BreadcrumbProps } from './Breadcrumb.types';
import styles from './Breadcrumb.module.scss';
import useBuildVariantProps from '../../../../modules/theme/useBuildVariantProps';
import { NavLink } from '../../Nav';

const Breadcrumb = (props: BreadcrumbProps) => {
  const { className, selected, navLinkType, ...restProps } = props;

  const variantProps = useBuildVariantProps(
    'breadcrumb',
    {
      type: selected ? 'selected' : 'Unselected',
    },
    {},
  );

  return (
    <NavLink
      className={cx(
        styles.breadcrumb,
        className,
      )}
      type={navLinkType}
      {...restProps}
      {...variantProps}
    />
  );
};

export default Breadcrumb;